import { Position } from './position.model';

export class Lineup {
    formation: string;
    positions: Position[] = [];
}



// WEBPACK FOOTER //
// ./src/app/shared/lineup.model.ts